import AppBar from './components/AppBar';
import Footer from './components/Footer';

import './styles/Common.css';
import renderHTML from 'react-render-html';
import JumboContainer from './components/common/JumboContainer';
import refundHTML from './html/refund_policy';

function RefundPolicy() {
  return (
    <>
      <AppBar alwaysSolid />
      <JumboContainer white>
        {renderHTML(refundHTML)}
      </JumboContainer>
      <Footer/>
    </>
  );
}

export default RefundPolicy;
